import { MEMBERSHIP_MODELS } from "@r-and-a-shared-ui/common-kontent-client";

export const rich_text_membership = (
  entry: MEMBERSHIP_MODELS.RichTextMembership,
) => {
  if (!entry || !entry?.elements) {
    return undefined;
  }
  const { elements } = entry || {};

  return {
    richTexts: elements?.membership_types?.linkedItems
  };
};

export default rich_text_membership;